    document.addEventListener('DOMContentLoaded', () => {
    const grid = document.querySelector('.iz-feature-grid');
    const cards = document.querySelectorAll('.iz-card');
    if (!grid || cards.length === 0) return;

    let isMobile = window.innerWidth <= 520;
    
    const dotsContainer = document.createElement('div');
    dotsContainer.className = 'iz-carousel-dots';
    if (isMobile) {
      grid.parentNode.insertBefore(dotsContainer, grid.nextSibling);
    }

    cards.forEach((_, i) => {
      const dot = document.createElement('div');
      dot.className = `iz-dot ${i === 0 ? 'active' : ''}`;
      dotsContainer.appendChild(dot);
    });

    const dots = document.querySelectorAll('.iz-dot');
    let currentIndex = 0;
    let carouselInterval;
    let isDragging = false;
    let startX, scrollLeft;

    function updateDots(index) {
      dots.forEach(d => d.classList.remove('active'));
      if (dots[index]) dots[index].classList.add('active');
    }

    // Kartı tam ekranın ortasına getirecek matematiksel hesap
    function getScrollPosition(index) {
      const card = cards[index];
      return card.offsetLeft - (grid.clientWidth - card.clientWidth) / 2;
    }

    function moveNext() {
      if (!isMobile || isDragging) return;
      currentIndex++;
      if (currentIndex >= cards.length) currentIndex = 0;
      
      grid.scrollTo({
        left: getScrollPosition(currentIndex),
        behavior: 'smooth'
      });
      updateDots(currentIndex);
    }

    function startAutoplay() {
      clearInterval(carouselInterval);
      if (isMobile) carouselInterval = setInterval(moveNext, 3000);
    }

    function calculateCurrentIndex() {
      let closestIndex = 0;
      let minDistance = Infinity;
      const centerOfGrid = grid.scrollLeft + grid.clientWidth / 2;

      cards.forEach((card, index) => {
        const centerOfCard = card.offsetLeft + card.clientWidth / 2;
        const distance = Math.abs(centerOfGrid - centerOfCard);
        if (distance < minDistance) {
          minDistance = distance;
          closestIndex = index;
        }
      });
      
      currentIndex = closestIndex;
      updateDots(currentIndex);
    }

    // Drag (Tut-Çek) İşlemleri
    grid.addEventListener('mousedown', (e) => {
      isDragging = true;
      startX = e.pageX - grid.offsetLeft;
      scrollLeft = grid.scrollLeft;
      clearInterval(carouselInterval);
      grid.style.scrollSnapType = 'none';
      grid.style.cursor = 'grabbing';
    });

    grid.addEventListener('mouseleave', () => {
      if (!isDragging) return;
      isDragging = false;
      grid.style.scrollSnapType = 'x mandatory';
      grid.style.cursor = 'grab';
      startAutoplay();
    });

    grid.addEventListener('mouseup', () => {
      isDragging = false;
      grid.style.scrollSnapType = 'x mandatory';
      grid.style.cursor = 'grab';
      setTimeout(calculateCurrentIndex, 100);
      startAutoplay();
    });

    grid.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      e.preventDefault();
      const x = e.pageX - grid.offsetLeft;
      const walk = (x - startX) * 1.5;
      grid.scrollLeft = scrollLeft - walk;
    });

    grid.addEventListener('scroll', () => {
      if (!isDragging) {
        clearTimeout(grid.scrollTimeout);
        grid.scrollTimeout = setTimeout(calculateCurrentIndex, 100);
      }
    }, { passive: true });

    grid.addEventListener('touchstart', () => clearInterval(carouselInterval), { passive: true });
    grid.addEventListener('touchend', () => setTimeout(startAutoplay, 2000), { passive: true });

    grid.style.cursor = 'grab';
    startAutoplay();

    window.addEventListener('resize', () => {
      isMobile = window.innerWidth <= 520;
      if (!isMobile) {
        clearInterval(carouselInterval);
        dotsContainer.style.display = 'none';
      } else {
        dotsContainer.style.display = 'flex';
        startAutoplay();
      }
    });
  });